module.exports = __webpack_public_path__ + "static/media/terms.de7f40f4.svg";